import React, { useEffect } from 'react';
import { useMytaverseEvent } from '@core/dashboard/providers';
import MobileExternalKeyboardDeviceControls from '@components/VideoGameCast/MobileExternalKeyboardDeviceControls';

const MobileExternalKeyboardControls = () => {
  const { shouldConnectToConference, isStreamLoaded } = useMytaverseEvent();

  const inputRef = React.useRef<HTMLInputElement>(null);

  useEffect(() => {
    if (isStreamLoaded && inputRef.current) {
      inputRef.current.focus();

      setTimeout(() => {
        if (inputRef.current) {
          inputRef.current.blur();
        }
      }, 3000);
    }
  }, [isStreamLoaded]);

  return (
    <>
      {shouldConnectToConference ? (
        <MobileExternalKeyboardDeviceControls />
      ) : (
        ''
      )}
      {isStreamLoaded && (
        <input
          type="text"
          inputMode="none"
          ref={inputRef}
          style={{ position: 'fixed', top: '-9999px', left: '-9999px' }}
        />
      )}
    </>
  );
};

export default MobileExternalKeyboardControls;
